/** Asset type category - stored in qhrms.AssetTypes.Category */
export enum AssetCategory {
  Physical = 'Physical',
  Software = 'Software',
}

/** Custom field input type - stored in AssetTypes.Fields JSON (fieldType) */
export enum AssetFieldType {
  Text = 'text',
  Number = 'number',
  Dropdown = 'dropdown',
  Date = 'date',
  Textarea = 'textarea',
  Checkbox = 'checkbox',
}

export const ASSET_CATEGORY_LABELS: Record<AssetCategory, string> = {
  [AssetCategory.Physical]: 'Physical',
  [AssetCategory.Software]: 'Software',
};

export const ASSET_FIELD_TYPE_LABELS: Record<AssetFieldType, string> = {
  [AssetFieldType.Text]: 'Text',
  [AssetFieldType.Number]: 'Number',
  [AssetFieldType.Dropdown]: 'Dropdown',
  [AssetFieldType.Date]: 'Date',
  [AssetFieldType.Textarea]: 'Long text',
  [AssetFieldType.Checkbox]: 'Checkbox',
};

export const ASSET_CATEGORIES = Object.values(AssetCategory);

export const ASSET_FIELD_TYPES = Object.values(AssetFieldType).map((value) => ({
  value,
  label: ASSET_FIELD_TYPE_LABELS[value],
}));

/** Filter token for asset types with no business unit */
export const ASSET_BU_FILTER_NONE = 'none';

/** Field types that support a list of dropdown option values */
export const ASSET_FIELD_TYPES_WITH_OPTIONS: AssetFieldType[] = [AssetFieldType.Dropdown];

export function isAssetFieldTypeWithOptions(fieldType: string): fieldType is AssetFieldType.Dropdown {
  return fieldType === AssetFieldType.Dropdown;
}
